<template>
  <div class="corpo-pagina">

    <!-- TITOLO -->
    <div class="row">
      <div class="col s12">
        <h4 class="page-title">{{ translation('msg.title.page.manage.room') }}: {{ roomData ? roomData.name : '' }}</h4>
      </div>
    </div>

    <div class="divider mb-4"></div>

    <!-- CONTROLLI / TOOLBAR -->
    <div class="row controls-row z-depth-1">
      <div class="col s12 m2 l2">
        <div class="input-field w-100 mt-0 mb-0">
          <select v-model="tableShape" id="table-shape-select" @change="seats = null">
            <option value="circle">{{ translation('shape.table.round') }}</option>
            <option value="rect">{{ translation('shape.table.rectangular') }}</option>
          </select>
          <label>{{ translation('shape.table') }}</label>
        </div>
      </div>
      <div class="col s12 m2 l2">
        <div class="input-field w-100 mt-0 mb-0">
          <select v-model="seats" id="table-seats-select" @change="creaTavoloManuale" :disabled="!tableShape">
            <option :value="null" disabled>{{ translation('select.seats.table') }}</option>
            <option v-for="n in 10" :key="n" :value="n">{{ n }} {{ translation('select.seats.table') }}</option>
          </select>
          <label>{{ translation('msg.seats.create.title') }}</label>
        </div>
      </div>
      <div class="col s12 m8 l8 action-buttons-col">

        <button @click="openAutoAssignModal" class="btn  purple darken-2 mr-2">
          <i class="material-icons left">auto_fix_high</i>{{ translation('btn.autoassignment') }}
        </button>
        <button @click="salvaStage" class="btn  green darken-1">
          <i class="material-icons left">save</i>{{ translation('btn.save.table') }}
        </button>
      </div>
    </div>

    <!-- MAIN CONTAINER (SIDEBAR + CANVAS) -->
    <div class="row table-manager-container">

      <!-- SIDEBAR OSPITI -->
      <div class="col s12 m4 l3 guest-sidebar-col">
        <div class="sidebar-card z-depth-1">

          <table>
            <tr>
              <td><h5 class="sidebar-title">{{ translation('table.guest.title') }} ({{ guestsToAssign.length }})</h5></td>
              <td style="width:35%"><button @click="resetAll" class="btn  red darken-1 mr-2">
          <i class="material-icons left">refresh</i>Reset
        </button> </td>
            </tr>
          </table>

          <div class="input-field w-100">
            <i class="material-icons prefix">search</i>
            <input
                id="search-guests"
                v-model="searchQuery"
                type="text"
                autocomplete="off"
                class="validate"
            >
            <label for="search-guests">{{ translation('Igotu.46') }}</label>
          </div>

          <p v-if="!guests.length" class="grey-text center-align">{{ translation('Igotu.46') }}</p>

          <div class="guest-list-scroll">
            <div v-for="guestSlot in guestsToAssign" :key="guestSlot.uniqueId"
                 class="guest-group-entry">
                <div
                    :id="'guest-figure-sidebar-' + guestSlot.uniqueId"
                    class="guest-figure z-depth-1"
                    :class="{
                        'main-guest': guestSlot.isMainGuest,
                        'dimension-accompanying': !guestSlot.isMainGuest
                    }"
                    :style="{ backgroundColor: getGuestColor(guestSlot.uid) }"
                    @mousedown="dragStartGroup(guestSlot.groupObject)"
                    :data-group-uid="guestSlot.uid">

                    <span>{{ guestSlot.displayName }}</span>

                    <span v-if="guestSlot.groupObject.accompanying_persons > 0 && guestSlot.isMainGuest"
                          class="accompanying-count">
                        +{{ guestSlot.groupObject.accompanying_persons }}
                    </span>
                </div>
            </div>
            <p v-if="searchQuery && guestsToAssign.length === 0" class="grey-text font-small italic center-align mt-3">
              {{ translation('msg.no.guest.table') }} "{{ searchQuery }}".
            </p>
          </div>
        </div>
      </div>

      <!-- CANVAS AREA -->
      <div class="col s12 m8 l9 canvas-col">
        <div id="container-wrapper"
             class="z-depth-2"
             :style="dynamicBackgroundStyle">
          <div id="container" class="droptarget"></div>
          <div class="resizable-handle" @mousedown="startStageResize" title="Ridimensiona sala">
            <i class="material-icons">open_with</i>
          </div>

          <!-- TOOLTIP HTML CON Z-INDEX MASSIMO -->
          <div v-if="tooltip.visible"
               class="custom-html-tooltip"
               :class="{ 'tooltip-below': tooltip.below }"
               :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }">
            {{ tooltip.text }}
          </div>
        </div>
      </div>

    </div>

    <!-- MODALE OSPITI TAVOLO -->
    <div v-if="tableGuestsModal.visible" class="table-guests-overlay" @click.self="closeTableGuestsModal">
      <div class="table-guests-card">
        <div class="table-guests-header">
          <h5>{{ tableGuestsModal.title }}</h5>
          <button @click="closeTableGuestsModal" class="btn-close-modern waves-effect">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="table-guests-body">
          <div class="table-name-action-row mb-4">
            <div class="input-field outlined-input-field mt-0 mb-0 flex-grow-1">
              <input
                  id="table-name-input"
                  v-model="tableGuestsModal.tableName"
                  type="text"
                  class="validate"
              >
              <label for="table-name-input" :class="{ active: tableGuestsModal.tableName }">Nome Tavolo</label>
            </div>
            <button @click="saveTableName" class="btn indigo darken-1 btn-modern ml-2">
              <i class="material-icons left">save</i>{{ translation('btn.save') }}
            </button>
          </div>

          <div class="section-divider mb-3"></div>
          <h6 class="guests-section-title mb-3">{{ translation('msg.guest.table') }} ({{ tableGuestsModal.guests.length }})</h6>

          <p v-if="tableGuestsModal.guests.length === 0" class="grey-text center-align py-4">{{ translation('msg.no.guest.table.seats') }}</p>

          <div v-else class="modern-guests-list mb-3">
            <div v-for="(guest, idx) in tableGuestsModal.guests" :key="idx" class="modern-guest-item">
              <div class="guest-avatar-icon">
                <i class="material-icons">person</i>
              </div>
              <span class="guest-item-name" :class="{ 'font-weight-bold': guest.isMain }">{{ guest.name }}</span>
              <span v-if="!guest.isMain" class="guest-tag-acc">{{ translation('app.igotu.mobile.accompagantore') }}</span>
            </div>
          </div>

          <div class="modal-footer-actions mt-4 pt-2 border-top">
            <button @click="deleteTable" class="btn  red darken-2 btn-modern">
              <i class="material-icons left">delete_forever</i>{{ translation('btn.delete.table') }}
            </button>
            <button @click="closeTableGuestsModal" class="btn grey lighten-1 grey-text text-darken-4 btn-modern">
              <i class="material-icons left">close</i>{{ translation('btn.annulla') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALE ASSEGNAZIONE AUTOMATICA E REGOLE -->
    <div v-if="autoAssignModal.visible" class="table-guests-overlay" @click.self="closeAutoAssignModal">
      <div class="table-guests-card" style="width: 650px; max-width: 95%;">
        <div class="table-guests-header">
          <h5>{{ translation('msg.auto.assignment.title') }}</h5>
          <button @click="closeAutoAssignModal" class="btn-close-modern waves-effect"><i class="material-icons">close</i></button>
        </div>

        <div class="table-guests-body">
          <p class="grey-text text-darken-1 mb-3">{{ translation('msg.auto.assignment.title.001') }}</p>

          <div class="rule-builder-box mb-3" style="background: #f8fafc;">
            <h6 class="font-weight-bold mb-2">{{ translation('opt.table.no.presente') }}</h6>
            <div class="row mb-0">
              <div class="col s12 m6">
                <div class="input-field mt-0 mb-0">
                  <select v-model="autoAssignModal.defaultShape" id="auto-table-shape">
                    <option value="circle">{{ translation('shape.table.round') }}</option>
                    <option value="rect">{{ translation('shape.table.rectangular') }}</option>
                  </select>
                  <label>{{ translation('shape.table.ple.auto') }}</label>
                </div>
              </div>
              <div class="col s12 m6">
                <div class="input-field mt-0 mb-0">
                  <select v-model="autoAssignModal.defaultSeats" id="auto-table-seats">
                    <option v-for="n in 10" :key="'auto-s-'+n" :value="n">{{ n }} {{ translation('seats.table') }}</option>
                  </select>
                  <label>{{ translation('msg.seats.created') }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="rule-builder-box mb-3">
            <div class="row mb-2">
              <div class="col s12 m4">
                <div class="input-field mt-0 mb-0">
                  <select v-model="autoAssignModal.newRule.guest1" id="rule-guest1">
                    <option :value="null" disabled>{{ translation('select.pax.a.roule') }}</option>
                    <option v-for="g in availableGuestsForRules" :key="g.uid" :value="g.uid">{{ g.name }} {{ g.surname }}</option>
                  </select>
                </div>
              </div>
              <div class="col s12 m4">
                <div class="input-field mt-0 mb-0">
                  <select v-model="autoAssignModal.newRule.type" id="rule-type">
                    <option value="same_table"> {{ translation('table.rule.001') }}</option>
                    <option value="diff_table"> {{ translation('table.rule.002') }}</option>
                    <option value="next_to"> {{ translation('table.rule.003') }}</option>
                  </select>
                </div>
              </div>
              <div class="col s12 m4">
                <div class="input-field mt-0 mb-0">
                  <select v-model="autoAssignModal.newRule.guest2" id="rule-guest2">
                    <option :value="null" disabled>{{ translation('select.pax.a.roule') }}</option>
                    <option v-for="g in availableGuestsForRules" :key="g.uid" :value="g.uid">{{ g.name }} {{ g.surname }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="center-align">
              <button @click="addRule" class="btn indigo darken-1 btn-small btn-modern">
                <i class="material-icons left">add</i>{{ translation('btn.add.rule') }}
              </button>
            </div>
          </div>

          <h6 class="font-weight-bold">{{ translation('title.rule.active') }} ({{ autoAssignModal.rules.length }})</h6>
          <div class="rules-list-scroll">

            <p class="red-text center-align mt-2">{{ translation('msg.more.time') }}</p>

            <p v-if="autoAssignModal.rules.length === 0" class="grey-text center-align mt-2">{{ translation('title.rule.no.active') }}</p>
            <ul v-else class="collection border-0">
              <li v-for="(rule, index) in autoAssignModal.rules" :key="index"
                  class="collection-item modern-rule-item"
                  :class="{ 'red lighten-5 border-red': rule.hasConflict }">
                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                  <span :class="{ 'red-text text-darken-4 font-weight-bold': rule.hasConflict }">
                    {{ getGuestName(rule.guest1) }}
                    <strong>{{ getRuleTypeText(rule.type) }}</strong>
                    {{ getGuestName(rule.guest2) }}
                    <span v-if="rule.hasConflict" class="chip red white-text ml-2" style="font-size: 11px; height: 20px; line-height: 20px;">{{ translation('msg.error.conflict.rule') }}</span>
                  </span>
                  <button @click="removeRule(index)" class="btn-flat red-text"><i class="material-icons">delete</i></button>
                </div>
              </li>
            </ul>
          </div>

          <div class="center-align mt-4">
            <button @click="runAutoAssign" class="btn green darken-2 btn-large btn-modern">
              <i class="material-icons left">bolt</i>{{ translation('btn.execute.assignme.auto') }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Konva from 'konva'
import konovaschema from '@/store/konovaschema.js'
import loadingStore from '@/store/loading'
import M from 'materialize-css'
import apiService from '@/services/apiService.js'
import translationStore from '@/store/translations'

export default {
  name: 'TableManager',
  data () {
    return {
      stage: null,

      stageWidth: 800,
      stageHeight: 600,
      minStageSize: 300,
      translationStore: translationStore,
      isResizing: false,
      initialMouseX: 0,
      initialMouseY: 0,
      initialStageWidth: 0,
      initialStageHeight: 0,

      searchQuery: '',

      tableShape: 'circle',
      seats: null,

      baseTableRadius: 38,
      baseRectWidth: 80,
      rectHeight: 55,
      minSpacePerPerson: 50,
      seatVisualRadius: 16,
      seatDistancePadding: 20,

      GUEST_KONVA_COLOR: '#ff4d4d',

      guests: [],
      guestColorMap: {},
      seatOccupancy: {},
      draggedGuestUid: null,

      tableLayer: null,
      figureLayer: null,
      transformer: null,
      tableCounter: 0,

      roomData: null,

      tooltip: {
        visible: false,
        text: '',
        x: 0,
        y: 0
      },

      tableGuestsModal: {
        visible: false,
        title: '',
        guests: [],
        tableName: '',
        tableGroup: null
      },
      uidEvent: null,

      autoAssignModal: {
        visible: false,
        rules: [],
        defaultShape: 'circle',
        defaultSeats: 6,
        newRule: {
          guest1: null,
          type: 'same_table',
          guest2: null
        }
      },

      imageOptions: [
        { value: 'modern', path: require('@/assets/img/table/modern.png') },
        { value: 'liberty', path: require('@/assets/img/table/liberty.png') },
        { value: 'principesco', path: require('@/assets/img/table/principesco.png') },
        { value: 'elegante', path: require('@/assets/img/table/elegante.png') },
        { value: 'natale', path: require('@/assets/img/table/natale.png') }
      ]
    }
  },

  computed: {
    translation () {
      return this.translationStore.getters.traduzione
    },
    konvaSchemaFromStore () {
      return konovaschema.getters.getKonvaSchema
    },

    roomDataFromStore () {
      return konovaschema.getters.getRoomData
    },

    dynamicBackgroundStyle () {
      const room = this.roomData
      if (!room) {
        return { backgroundColor: '#f0f0f0' }
      }

      if (room.color) {
        return {
          backgroundColor: room.color,
          backgroundImage: 'none'
        }
      }

      const imgValue = room.img
      const selectedOption = this.imageOptions.find(opt => opt.value === imgValue)

      if (selectedOption) {
        return {
          backgroundImage: `url(${selectedOption.path})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: 'transparent'
        }
      }

      return { backgroundColor: '#f0f0f0' }
    },

    guestsToAssign () {
      const allSeats = []
      const searchTerm = this.searchQuery.toLowerCase().trim()
      const assignedUids = this.getAssignedGuestUidsAcrossAllRooms()

      this.guests
        .map(g => ({
          ...g,
          groupId: 'guest-figure-' + g.uid,
          totalSeatsNeeded: 1 + (g.accompanying_persons || 0)
        }))
        .filter(g => {
          if (assignedUids.has(g.uid)) return false

          if (searchTerm) {
            const fullName = `${g.name} ${g.surname}`.toLowerCase()
            return fullName.includes(searchTerm)
          }
          return true
        })
        .forEach(group => {
          allSeats.push({
            uniqueId: `${group.uid}-main`,
            uid: group.uid,
            groupId: group.groupId,
            displayName: `${group.name} ${group.surname}`,
            isMainGuest: true,
            groupObject: group
          })

          for (let i = 1; i <= group.accompanying_persons; i++) {
            allSeats.push({
              uniqueId: `${group.uid}-acc-${i}`,
              uid: group.uid,
              groupId: group.groupId,
              displayName: `${group.name} ${group.surname} (Acc. ${i})`,
              isMainGuest: false,
              groupObject: group
            })
          }
        })
      return allSeats
    },

    availableGuestsForRules () {
      const assignedUids = this.getAssignedGuestUidsAcrossAllRooms()
      return this.guests.filter(g => !assignedUids.has(g.uid))
    }
  },

  async mounted () {
    this.loadGuestsFromLocalStorage()
    this.syncRoomAndSchemaFromStorageOrRoute()
    this.loadRoomData()
    this.loadStageFromVuex()

    document.addEventListener('mousemove', this.handleStageResize)
    document.addEventListener('mouseup', this.stopStageResize)
    this.initMaterializeComponents()
  },

  beforeDestroy () {
    document.removeEventListener('mousemove', this.handleStageResize)
    document.removeEventListener('mouseup', this.stopStageResize)
  },

  methods: {

    getAssignedGuestUidsAcrossAllRooms () {
      const assignedUids = new Set()

      // 1. Controlla lo stato locale reattivo della stanza corrente
      if (this.seatOccupancy) {
        Object.values(this.seatOccupancy).forEach(figureId => {
          if (figureId && typeof figureId === 'string' && figureId.startsWith('guest-figure-')) {
            const uid = figureId.replace('guest-figure-', '')
            assignedUids.add(uid)
          }
        })
      }

      // 2. Controlla le ALTRE stanze presenti in SettingsStore
      try {
        const settingsString = localStorage.getItem('SettingsStore')
        if (settingsString) {
          const settings = JSON.parse(settingsString)
          const rooms = settings.eventModel && settings.eventModel.rooms ? settings.eventModel.rooms : []

          const currentRoom = this.roomDataFromStore || this.roomData || {}
          const currentRoomId = currentRoom.uid || currentRoom.id || currentRoom.uuid || this.$route.params.uid || this.$route.query.uid

          rooms.forEach(room => {
            const roomId = room.uid || room.id || room.uuid
            // Salta la stanza corrente per evitare conflitti con i dati asincroni di localStorage
            if (currentRoomId && roomId === currentRoomId) {
              return
            }

            const occupancy = room.jsonable && room.jsonable.seatOccupancy ? room.jsonable.seatOccupancy : {}
            Object.values(occupancy).forEach(figureId => {
              if (figureId && typeof figureId === 'string' && figureId.startsWith('guest-figure-')) {
                const uid = figureId.replace('guest-figure-', '')
                assignedUids.add(uid)
              }
            })
          })
        }
      } catch (e) {
        // console.error('Errore nel controllo delle sale in SettingsStore:', e)
      }

      return assignedUids
    },

    syncRoomAndSchemaFromStorageOrRoute () {
      const routeUid = this.$route.params.uid

      if (!this.roomDataFromStore || (routeUid && this.roomDataFromStore.uid !== routeUid)) {
        const savedInfo = localStorage.getItem('activeTableInfo')
        if (savedInfo) {
          try {
            const parsedInfo = JSON.parse(savedInfo)
            if (!routeUid || parsedInfo.uid === routeUid) {
              konovaschema.commit('setRoomData', parsedInfo)
            }
          } catch (e) {
            // console.error('Errore nel parsing di activeTableInfo:', e)
          }
        }
      }

      if (!this.konvaSchemaFromStore) {
        const savedSchema = localStorage.getItem('activeTableSchema')
        if (savedSchema) {
          try {
            const parsedSchema = JSON.parse(savedSchema)
            konovaschema.dispatch('aggiornakonova', parsedSchema)
          } catch (e) {
            // console.error('Errore nel parsing di activeTableSchema:', e)
          }
        }
      }
    },
    initMaterializeComponents () {
      this.$nextTick(() => {
        if (typeof M !== 'undefined') {
          M.updateTextFields()
          const selects = document.querySelectorAll('select')
          selects.forEach(selectElem => {
            const instance = M.FormSelect.getInstance(selectElem)
            if (instance) {
              instance.destroy()
            }
            M.FormSelect.init(selectElem)
          })
        }
      })
    },

    attachSeatEvents (seatGroup, tableGroup) {
      seatGroup.off('mousedown touchstart mouseenter mouseleave')

      seatGroup.on('mousedown touchstart', () => {
        if (seatGroup.getAttr('isOccupied')) {
          this.handleSeatDragStart(seatGroup, tableGroup)
        }
      })

      seatGroup.on('mouseenter', () => {
        if (seatGroup.getAttr('isOccupied')) {
          const sId = seatGroup.id()
          const fId = this.seatOccupancy[sId]
          if (fId) {
            const guestUid = fId.replace('guest-figure-', '')
            const guestObject = this.guests.find(g => g.uid === guestUid)
            if (guestObject) {
              const seatGuestsMap = {}
              tableGroup.find('.seat-group').forEach(sg => {
                const currentSId = sg.id()
                const currentFId = this.seatOccupancy[currentSId]
                if (currentFId === fId) {
                  if (!seatGuestsMap[currentFId]) seatGuestsMap[currentFId] = []
                  seatGuestsMap[currentFId].push(sg)
                }
              })
              const guestSeatList = seatGuestsMap[fId] || []
              guestSeatList.sort((a, b) => parseInt(a.id().split('-').pop()) - parseInt(b.id().split('-').pop()))
              const seatIdx = guestSeatList.findIndex(sg => sg.id() === sId)

              let displayName = `${guestObject.name} ${guestObject.surname}`
              if (seatIdx > 0) {
                displayName += ` (Acc. ${seatIdx})`
              }

              const absPos = seatGroup.getAbsolutePosition()
              const renderBelow = absPos.y - 30 < 0

              this.tooltip = {
                visible: true,
                text: displayName,
                x: absPos.x,
                y: renderBelow ? (absPos.y + 18) : (absPos.y - 12),
                below: renderBelow
              }
            }
          }
        }
      })

      seatGroup.on('mouseleave', () => {
        this.tooltip.visible = false
      })
    },

    loadRoomData () {
      this.roomData = this.roomDataFromStore
      if (this.roomData) {
        this.uidEvent = this.roomData.event_uid || this.roomData.event_id || null
        if (this.roomData.jsonable) {
          if (this.roomData.jsonable.seatOccupancy) {
            this.seatOccupancy = this.roomData.jsonable.seatOccupancy
          }
          if (this.roomData.jsonable.width) {
            this.stageWidth = this.roomData.jsonable.width
          }
          if (this.roomData.jsonable.height) {
            this.stageHeight = this.roomData.jsonable.height
          }
        }
      }
    },

    loadStageFromVuex () {
      const konvaSchema = this.konvaSchemaFromStore

      if (konvaSchema) {
        try {
          this.stage = Konva.Node.create(konvaSchema, 'container')
          this.tableLayer = this.stage.findOne('.TableLayer')
          this.figureLayer = this.stage.findOne('.FigureLayer')
          this.transformer = this.tableLayer.findOne('Transformer')
          this.stageWidth = this.stage.width()
          this.stageHeight = this.stage.height()
          this.recalculateStateFromStage()
          this.stage.off('click tap').on('click tap', this.handleStageClick)
          this.stage.draw()
        } catch (e) {
          // console.error('Errore nel caricamento dello Stage da Vuex:', e)
          this.initializeStage()
        }
      } else {
        this.initializeStage()
      }
    },

    recalculateStateFromStage () {
      if (!this.seatOccupancy || Object.keys(this.seatOccupancy).length === 0) {
        this.seatOccupancy = {}
      }
      let maxTableNumber = 0

      this.tableLayer.find('.gruppo_tavolo').forEach(group => {
        const tableId = group.id()
        const match = tableId.match(/table-group-(\d+)/)
        if (match) {
          maxTableNumber = Math.max(maxTableNumber, parseInt(match[1]))
        }

        group.off('transform contextmenu dragmove mouseenter mouseleave')
        group.on('transform', () => {
          this.tooltip.visible = false
          this.handleTableTransform(group)
        })
        group.on('dragmove', () => {
          this.tooltip.visible = false
        })
        group.on('contextmenu', (e) => {
          e.evt.preventDefault()
          this.tooltip.visible = false
          this.handleTableRightClick(group)
        })
        group.on('mouseenter', () => {
          const tableMatch = group.id().match(/table-group-(\d+)/)
          const tableNumber = tableMatch ? tableMatch[1] : '?'
          const customName = group.getAttr('tableName')
          const numSeats = group.getAttr('originalNumSeats')
          const shape = group.getAttr('tableShape')
          const tableElem = group.findOne('.table')

          let tooltipText = `${this.translation('table.lab.msg')} ${tableNumber} (${numSeats} ${this.translation('seats.table')})`
          if (customName) {
            tooltipText = `${customName} (${this.translation('table.lab.msg')} ${tableNumber} - ${numSeats} ${this.translation('seats.table')})`
          }

          const seatedGuests = this.getTableSeatedGuests(group)
          if (seatedGuests.length > 0) {
            tooltipText += '\n\nOspiti seduti:\n• ' + seatedGuests.map(g => g.name).join('\n• ')
          }

          const absPos = group.getAbsolutePosition()
          const radiusOrHalf = tableElem ? (shape === 'circle' ? tableElem.radius() : tableElem.height() / 2) : 40

          // Se il tavolo è troppo vicino al bordo superiore, mostra il tooltip sotto anziché sopra
          const renderBelow = absPos.y - radiusOrHalf - 40 < 0

          this.tooltip = {
            visible: true,
            text: tooltipText,
            x: absPos.x,
            y: renderBelow ? (absPos.y + radiusOrHalf + 12) : (absPos.y - radiusOrHalf - 15),
            below: renderBelow
          }
        })
        group.on('mouseleave', () => {
          this.tooltip.visible = false
        })

        group.find('.seat-group').forEach(seatGroup => {
          const userIcon = seatGroup.findOne('.user-icon')
          if (userIcon && userIcon.visible()) {
            const guestUid = seatGroup.getAttr('guestUid')
            if (guestUid) {
              this.$set(this.seatOccupancy, seatGroup.id(), 'guest-figure-' + guestUid)
            }
          }
          this.attachSeatEvents(seatGroup, group)
        })

        this.handleTableTransform(group)
      })

      this.tableCounter = maxTableNumber
      this.updateTableDragBounds()

      this.guests.forEach(g => {
        this.restoreSidebarVisibility(g.uid)
      })
    },

    startStageResize (e) {
      this.isResizing = true
      this.initialMouseX = e.clientX
      this.initialMouseY = e.clientY
      this.initialStageWidth = this.stageWidth
      this.initialStageHeight = this.stageHeight
      e.preventDefault()
    },

    handleStageResize (e) {
      if (!this.isResizing) return

      const dx = e.clientX - this.initialMouseX
      const dy = e.clientY - this.initialMouseY

      const newWidth = Math.max(this.minStageSize, this.initialStageWidth + dx)
      const newHeight = Math.max(this.minStageSize, this.initialStageHeight + dy)

      this.stageWidth = newWidth
      this.stageHeight = newHeight

      this.updateKonvaStageDimensions()
    },

    stopStageResize () {
      this.isResizing = false
    },

    updateKonvaStageDimensions () {
      if (this.stage) {
        this.stage.width(this.stageWidth)
        this.stage.height(this.stageHeight)

        this.updateTableDragBounds()

        const borderRect = this.stage.findOne('#stage-border')
        if (borderRect) {
          borderRect.width(this.stageWidth)
          borderRect.height(this.stageHeight)
        }
        this.stage.draw()
      }
    },

    getTableRadiusOrHalfWidth (group) {
      const shape = group.getAttr('tableShape')
      const tableElem = group.findOne('.table')
      if (!tableElem) return this.baseTableRadius + this.seatVisualRadius
      if (shape === 'circle') {
        return (tableElem.radius() || this.baseTableRadius) + this.seatVisualRadius + 5
      } else {
        const w = tableElem.width() || this.baseRectWidth
        return (w / 2) + this.seatVisualRadius + 5
      }
    },

    getTableDragBoundFunc (group) {
      return (pos) => {
        const radiusOrHalf = this.getTableRadiusOrHalfWidth(group)
        const minX = radiusOrHalf
        const minY = radiusOrHalf
        const maxX = this.stageWidth - radiusOrHalf
        const maxY = this.stageHeight - radiusOrHalf

        const newX = Math.min(Math.max(pos.x, minX), maxX)
        const newY = Math.min(Math.max(pos.y, minY), maxY)

        return { x: newX, y: newY }
      }
    },

    updateTableDragBounds () {
      this.tableLayer?.find('.gruppo_tavolo').forEach(group => {
        group.setAttr('dragBoundFunc', this.getTableDragBoundFunc(group))
        const radiusOrHalf = this.getTableRadiusOrHalfWidth(group)
        group.x(Math.min(Math.max(group.x(), radiusOrHalf), this.stageWidth - radiusOrHalf))
        group.y(Math.min(Math.max(group.y(), radiusOrHalf), this.stageHeight - radiusOrHalf))
      })
      this.tableLayer?.draw()
    },

    loadGuestsFromLocalStorage () {
      try {
        const settingsString = localStorage.getItem('SettingsStore')
        if (settingsString) {
          const settings = JSON.parse(settingsString)
          const guestsArray = settings.eventModel && settings.eventModel.guests ? settings.eventModel.guests : []
          if (guestsArray.length > 0) {
            this.guests = guestsArray.map((g) => ({
              ...g,
              accompanying_persons: g.accompanying_persons || 0
            }))
            this.guests.forEach(g => {
              this.$set(this.guestColorMap, g.uid, this.getRandomColor())
            })
          }
        }
      } catch (e) {
        // console.error('Errore durante il caricamento degli ospiti:', e)
      }
    },

    getRandomColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },

    getGuestColor (uid) {
      return this.guestColorMap[uid] || '#000000'
    },

    initializeStage () {
      this.stage = new Konva.Stage({
        container: 'container',
        width: this.stageWidth,
        height: this.stageHeight
      })

      const borderLayer = new Konva.Layer()
      const borderRect = new Konva.Rect({
        x: 0,
        y: 0,
        width: this.stageWidth,
        height: this.stageHeight,
        stroke: '#ccc',
        strokeWidth: 1,
        id: 'stage-border'
      })
      borderLayer.add(borderRect)
      this.stage.add(borderLayer)

      this.tableLayer = new Konva.Layer({ name: 'TableLayer' })
      this.stage.add(this.tableLayer)

      this.figureLayer = new Konva.Layer({ name: 'FigureLayer' })
      this.stage.add(this.figureLayer)

      this.transformer = new Konva.Transformer({
        rotateEnabled: true,
        borderStroke: 'blue',
        anchorFill: 'blue',
        anchorStroke: 'blue',
        enabledAnchors: []
      })
      this.tableLayer.add(this.transformer)

      this.updateTableDragBounds()
      this.stage.on('click tap', this.handleStageClick)
    },

    handleStageClick (e) {
      const target = e.target

      this.tooltip.visible = false

      if (target === this.stage || target.name() === 'seat' || target.name() === 'user-icon' || target.id() === 'stage-border') {
        this.transformer.nodes([])
        this.tableLayer.draw()
        return
      }

      const group = target.getParent()
      if (group && group.name() === 'gruppo_tavolo') {
        this.transformer.nodes([group])
        this.tableLayer.draw()
      } else {
        this.transformer.nodes([])
        this.tableLayer.draw()
      }
    },

    createTableEntity (xPos, yPos, numSeats, shape, tableName = '') {
      this.tableCounter++

      if (xPos + 80 > this.stageWidth) {
        this.stageWidth = xPos + 120
      }
      if (yPos + 80 > this.stageHeight) {
        this.stageHeight = yPos + 120
      }
      this.updateKonvaStageDimensions()

      const group = new Konva.Group({
        id: `table-group-${this.tableCounter}`,
        x: xPos,
        y: yPos,
        draggable: true,
        name: 'gruppo_tavolo'
      })

      group.setAttr('originalNumSeats', numSeats)
      group.setAttr('tableShape', shape)
      group.setAttr('tableName', tableName)
      group.setAttr('dragBoundFunc', this.getTableDragBoundFunc(group))

      group.on('transform', () => {
        this.tooltip.visible = false
        this.handleTableTransform(group)
      })
      group.on('dragmove', () => {
        this.tooltip.visible = false
      })
      group.on('contextmenu', (e) => {
        e.evt.preventDefault()
        this.tooltip.visible = false
        this.handleTableRightClick(group)
      })

      group.on('mouseenter', () => {
        const tableMatch = group.id().match(/table-group-(\d+)/)
        const tableNumber = tableMatch ? tableMatch[1] : '?'
        const customName = group.getAttr('tableName')
        const numSeats = group.getAttr('originalNumSeats')
        const shape = group.getAttr('tableShape')
        const tableElem = group.findOne('.table')

        let tooltipText = `${this.translation('table.lab.msg')} ${tableNumber} (${numSeats} ${this.translation('seats.table')})`
        if (customName) {
          tooltipText = `${customName} (${this.translation('table.lab.msg')} ${tableNumber} - ${numSeats} ${this.translation('seats.table')})`
        }

        const seatedGuests = this.getTableSeatedGuests(group)
        if (seatedGuests.length > 0) {
          tooltipText += '\n\nOspiti seduti:\n• ' + seatedGuests.map(g => g.name).join('\n• ')
        }

        const absPos = group.getAbsolutePosition()
        const radiusOrHalf = tableElem ? (shape === 'circle' ? tableElem.radius() : tableElem.height() / 2) : 40

        // Se il tavolo è troppo vicino al bordo superiore, mostra il tooltip sotto anziché sopra
        const renderBelow = absPos.y - radiusOrHalf - 40 < 0

        this.tooltip = {
          visible: true,
          text: tooltipText,
          x: absPos.x,
          y: renderBelow ? (absPos.y + radiusOrHalf + 12) : (absPos.y - radiusOrHalf - 15),
          below: renderBelow
        }
      })

      group.on('mouseleave', () => {
        this.tooltip.visible = false
      })

      if (shape === 'circle') {
        const tableRadius = this.baseTableRadius

        const tableBase = new Konva.Circle({
          name: 'table-base',
          x: 0,
          y: 0,
          radius: tableRadius + 2,
          fill: '#ffffff',
          stroke: '#e0e0e0',
          strokeWidth: 1
        })
        group.add(tableBase)

        const tableElement = new Konva.Circle({
          name: 'table',
          x: 0,
          y: 0,
          radius: tableRadius,
          fill: '#ffffff',
          stroke: '#dcdcdc',
          strokeWidth: 1.5,
          shadowColor: 'rgba(0,0,0,0.1)',
          shadowBlur: 6,
          shadowOffsetY: 3,
          tableRadius: tableRadius
        })
        group.add(tableElement)

        const centerDeco = new Konva.Circle({
          name: 'table-deco',
          x: 0,
          y: 0,
          radius: tableRadius * 0.35,
          fill: '#fafafa',
          stroke: '#eeeeee',
          strokeWidth: 1
        })
        group.add(centerDeco)
      } else if (shape === 'rect') {
        const seatsPerLongSide = Math.floor(Math.max(0, numSeats - 2) / 2)
        let w = (seatsPerLongSide + 1) * this.minSpacePerPerson
        w = Math.max(w, this.baseRectWidth)

        const tableBase = new Konva.Rect({
          name: 'table-base',
          x: -(w + 4) / 2,
          y: -(this.rectHeight + 4) / 2,
          width: w + 4,
          height: this.rectHeight + 4,
          cornerRadius: 8,
          fill: '#ffffff',
          stroke: '#e0e0e0',
          strokeWidth: 1
        })
        group.add(tableBase)

        const tableElement = new Konva.Rect({
          name: 'table',
          x: -w / 2,
          y: -this.rectHeight / 2,
          width: w,
          height: this.rectHeight,
          cornerRadius: 6,
          fill: '#ffffff',
          stroke: '#dcdcdc',
          strokeWidth: 1.5,
          shadowColor: 'rgba(0,0,0,0.1)',
          shadowBlur: 6,
          shadowOffsetY: 3,
          tableWidth: w,
          tableHeight: this.rectHeight
        })
        group.add(tableElement)
      }

      this.generateSeats(group, numSeats)
      this.tableLayer.add(group)
      return group
    },

    creaTavoloManuale () {
      const numSeats = parseInt(this.seats)
      const gridSpacing = 160
      const xPos = 120 + ((this.tableCounter) % 4) * gridSpacing
      const yPos = 120 + Math.floor((this.tableCounter) / 4) * gridSpacing

      const group = this.createTableEntity(xPos, yPos, numSeats, this.tableShape, '')

      this.transformer.nodes([group])
      this.updateTableDragBounds()
      this.tableLayer.draw()
      this.seats = null
      this.initMaterializeComponents()
    },

    handleTableTransform (tableGroup) {
      const rot = tableGroup.rotation()
      tableGroup.find('.user-icon').forEach(icon => {
        icon.rotation(-rot)
      })
      this.tableLayer.draw()
    },

    handleTableRightClick (tableGroup) {
      const tableId = tableGroup.id()
      const match = tableId.match(/table-group-(\d+)/)
      const tableNumber = match ? match[1] : '?'
      const numSeats = tableGroup.getAttr('originalNumSeats')
      const guests = this.getTableSeatedGuests(tableGroup)

      const currentTableName = tableGroup.getAttr('tableName') || `Tavolo ${tableNumber}`

      this.tableGuestsModal = {
        visible: true,
        title: `${this.translation('table.lab.msg')} ${tableNumber} (${numSeats} ${this.translation('seats.table')})`,
        guests: guests,
        tableName: currentTableName,
        tableGroup: tableGroup
      }
      this.initMaterializeComponents()
    },

    closeTableGuestsModal () {
      this.tableGuestsModal.visible = false
    },

    updateTableLabel (group, name) {},

    saveTableName () {
      if (!this.tableGuestsModal.tableGroup) return
      const group = this.tableGuestsModal.tableGroup
      const name = this.tableGuestsModal.tableName.trim()

      // Aggiorna il nome nel canvas
      group.setAttr('tableName', name)
      this.updateTableLabel(group, name)
      this.tableLayer.draw()

      // 1. Chiude la modale
      this.closeTableGuestsModal()

      // 2. Lancia il salvataggio completo (JSON + API)
      this.salvaStage()

      // Mostra la notifica di successo
      M.toast({ html: this.translation('msg.name.table.saved,'), classes: 'green' })
    },

    deleteTable () {
      if (!this.tableGuestsModal.tableGroup) return
      const tableGroup = this.tableGuestsModal.tableGroup
      const tableId = tableGroup.id()

      Object.keys(this.seatOccupancy).forEach(seatId => {
        if (seatId.startsWith(tableId + '-seat-')) {
          this.$delete(this.seatOccupancy, seatId)
        }
      })

      const currentNodes = this.transformer.nodes()
      if (currentNodes.includes(tableGroup)) {
        this.transformer.nodes([])
      }

      tableGroup.destroy()
      this.tableLayer.draw()

      this.salvaStage()
      this.closeTableGuestsModal()
      M.toast({ html: this.translation('msg.table.deleted'), classes: 'red darken-1' })
    },

    openAutoAssignModal () {
      this.autoAssignModal.visible = true
      this.$nextTick(() => {
        this.initMaterializeComponents()
      })
    },

    closeAutoAssignModal () {
      this.autoAssignModal.visible = false
    },

    getGuestName (uid) {
      const g = this.guests.find(x => x.uid === uid)
      return g ? `${g.name} ${g.surname}` : this.translation('msg.unkonw.guest.table')
    },

    getRuleTypeText (type) {
      switch (type) {
        case 'same_table': return this.translation('table.rule.001')
        case 'diff_table': return this.translation('table.rule.002')
        case 'next_to': return this.translation('table.rule.003')
        default: return ''
      }
    },

    addRule () {
      const r = this.autoAssignModal.newRule
      if (!r.guest1 || !r.guest2) {
        M.toast({ html: this.translation('msg.guest.entr'), classes: 'orange' })
        return
      }
      if (r.guest1 === r.guest2) {
        M.toast({ html: this.translation('msg.guest.entr.dupl'), classes: 'orange' })
        return
      }

      this.autoAssignModal.rules.push({
        guest1: r.guest1,
        type: r.type,
        guest2: r.guest2,
        hasConflict: false
      })

      this.checkRuleConflicts()

      this.autoAssignModal.newRule.guest1 = null
      this.autoAssignModal.newRule.guest2 = null
      this.initMaterializeComponents()
    },

    removeRule (index) {
      this.autoAssignModal.rules.splice(index, 1)
      this.checkRuleConflicts()
    },

    checkRuleConflicts () {
      this.autoAssignModal.rules.forEach(r => { r.hasConflict = false })
      const rules = this.autoAssignModal.rules

      for (let i = 0; i < rules.length; i++) {
        for (let j = i + 1; j < rules.length; j++) {
          const r1 = rules[i]
          const r2 = rules[j]

          const samePair = (r1.guest1 === r2.guest1 && r1.guest2 === r2.guest2) ||
                           (r1.guest1 === r2.guest2 && r1.guest2 === r2.guest1)

          if (samePair) {
            if ((r1.type === 'same_table' && r2.type === 'diff_table') ||
                (r1.type === 'diff_table' && r2.type === 'same_table')) {
              r1.hasConflict = true
              r2.hasConflict = true
            }
          }
        }
      }
    },

    async runAutoAssign () {
      this.closeAutoAssignModal()
      loadingStore.commit('setLoading', true)

      // 1. Recupera activeTableInfo corrente da localStorage o store
      const savedActiveTableInfo = localStorage.getItem('activeTableInfo')
      const tableInfoJson = savedActiveTableInfo ? JSON.parse(savedActiveTableInfo) : (this.roomDataFromStore || this.roomData || {})

      const roomId = tableInfoJson.uid || tableInfoJson.id || tableInfoJson.uuid || this.$route.params.uid || this.$route.query.uid

      if (!roomId) {
        loadingStore.commit('setLoading', false)
        M.toast({ html: this.translation('msg.error.table.not.found'), classes: 'red' })
        return
      }

      // Controllo conflitti nelle regole prima dell'invio
      const hasConflict = this.autoAssignModal.rules.some(r => r.hasConflict)
      if (hasConflict) {
        loadingStore.commit('setLoading', false)
        M.toast({ html: this.translation('msg.error.conflict.table'), classes: 'red' })
        return
      }

      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        loadingStore.commit('setLoading', false)
        this.$router.push('/error')
        return
      }

      // 2. Prepara il payload con guests, activeTableInfo e rules
      const payload = {
        defaultShape: this.autoAssignModal.defaultShape || 'circle',
        defaultSeats: parseInt(this.autoAssignModal.defaultSeats) || 6,
        rules: this.autoAssignModal.rules,
        guests: this.guests,
        activeTableInfo: tableInfoJson
      }

      try {
        // Chiamata allo script PHP sul server
        const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        const url = `${process.env.VUE_APP_URL_DOMAIN}/ajax/auto-assign.php?control=${session}`
        const updatedTableInfo = await apiService.sendRequestWithBearer('POST', url, token, payload)

        // 3. Re-iniezione del JSON restituito dal PHP nello stage e in localStorage
        if (updatedTableInfo) {
          konovaschema.commit('setRoomData', updatedTableInfo)
          localStorage.setItem('activeTableInfo', JSON.stringify(updatedTableInfo))

          if (updatedTableInfo.jsonable && updatedTableInfo.jsonable.seatOccupancy) {
            this.seatOccupancy = { ...updatedTableInfo.jsonable.seatOccupancy }
          }

          if (updatedTableInfo.jsonable && updatedTableInfo.jsonable.konva_schema) {
            konovaschema.dispatch('aggiornakonova', updatedTableInfo.jsonable.konva_schema)
            localStorage.setItem('activeTableSchema', JSON.stringify(updatedTableInfo.jsonable.konva_schema))
          }

          // Aggiornamento visivo dello stage
          this.loadRoomData()
          this.loadStageFromVuex()

          // 4. Ridisegna visivamente i tavoli e posiziona gli ospiti sui posti
          if (this.tableLayer) {
            const tables = this.tableLayer.find('.gruppo_tavolo')
            tables.forEach(t => {
              if (typeof this.generateSeats === 'function') {
                this.generateSeats(t, t.getAttr('originalNumSeats'))
              }
            })
            this.tableLayer.draw()
          }
        }

        // Salva definitivamente lo stato aggiornato
        this.salvaStage()

        M.toast({ html: this.translation('msg.auto.assign.complete'), classes: 'green' })
      } catch (error) {
        M.toast({ html: this.translation('msg.error.save.001'), classes: 'red' })
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },

    runAutoAssignxxx () {
      this.closeAutoAssignModal()
      loadingStore.commit('setLoading', true)
      let tables = this.tableLayer.find('.gruppo_tavolo')

      const assignedUids = this.getAssignedGuestUidsAcrossAllRooms()
      const unassignedGuests = this.guests.filter(g => !assignedUids.has(g.uid))

      // Raggruppa ogni ospite principale con i suoi relativi accompagnatori
      const guestGroups = unassignedGuests.map(g => ({
        uid: g.uid,
        groupId: 'guest-figure-' + g.uid,
        name: `${g.name} ${g.surname}`,
        size: 1 + (g.accompanying_persons || 0),
        slots: [
          { uniqueId: `${g.uid}-main`, uid: g.uid, groupId: 'guest-figure-' + g.uid, isMainGuest: true },
          ...Array.from({ length: g.accompanying_persons || 0 }, (_, i) => ({
            uniqueId: `${g.uid}-acc-${i + 1}`,
            uid: g.uid,
            groupId: 'guest-figure-' + g.uid,
            isMainGuest: false
          }))
        ]
      }))

      const totalGuestsNeeded = guestGroups.reduce((acc, g) => acc + g.size, 0)
      let totalAvailableSeats = tables.reduce((acc, t) => acc + t.getAttr('originalNumSeats'), 0)

      if (totalAvailableSeats < totalGuestsNeeded) {
        const defaultSeats = parseInt(this.autoAssignModal.defaultSeats) || 6
        const shapeToCreate = this.autoAssignModal.defaultShape || 'circle'

        while (totalAvailableSeats < totalGuestsNeeded) {
          const gridSpacing = 160
          const xPos = 120 + ((this.tableCounter) % 4) * gridSpacing
          const yPos = 120 + Math.floor((this.tableCounter) / 4) * gridSpacing

          this.createTableEntity(xPos, yPos, defaultSeats, shapeToCreate, '')
          totalAvailableSeats += defaultSeats
        }

        tables = this.tableLayer.find('.gruppo_tavolo')
        this.transformer.nodes([])
        this.updateTableDragBounds()
        this.tableLayer.draw()
      }

      const hasConflict = this.autoAssignModal.rules.some(r => r.hasConflict)
      if (hasConflict) {
        loadingStore.commit('setLoading', false)
        M.toast({ html: this.translation('msg.error.conflict.table'), classes: 'red' })
        return
      }

      const newOccupancy = { ...this.seatOccupancy }
      const assignedGroupUids = new Set()

      const nextToRules = this.autoAssignModal.rules.filter(r => r.type === 'next_to' && !r.hasConflict)
      const sameTableRules = this.autoAssignModal.rules.filter(r => r.type === 'same_table' && !r.hasConflict)
      const diffTableRules = this.autoAssignModal.rules.filter(r => r.type === 'diff_table' && !r.hasConflict)

      const getTableForUid = (uid) => {
        for (const sId in newOccupancy) {
          if (newOccupancy[sId] === 'guest-figure-' + uid) {
            for (const t of tables) {
              if (t.findOne('#' + sId)) return t
            }
          }
        }
        return null
      }

      const findTableForSize = (requiredSize) => {
        for (const table of tables) {
          const tSeats = table.find('.seat-group')
          const freeSeats = tSeats.filter(s => !newOccupancy[s.id()])
          if (freeSeats.length >= requiredSize) {
            for (let i = 0; i < tSeats.length; i++) {
              const consecutive = []
              let possible = true
              for (let j = 0; j < requiredSize; j++) {
                const seat = tSeats[(i + j) % tSeats.length]
                if (newOccupancy[seat.id()]) {
                  possible = false
                  break
                }
                consecutive.push(seat)
              }
              if (possible && consecutive.length === requiredSize) {
                return { table, seats: consecutive }
              }
            }
            return { table, seats: freeSeats.slice(0, requiredSize) }
          }
        }
        return null
      }

      // 1. Gestione vincoli "next_to"
      nextToRules.forEach(rule => {
        const g1 = guestGroups.find(g => g.uid === rule.guest1 && !assignedGroupUids.has(g.uid))
        const g2 = guestGroups.find(g => g.uid === rule.guest2 && !assignedGroupUids.has(g.uid))
        if (g1 && g2) {
          const totalSize = g1.size + g2.size
          let tableObj = findTableForSize(totalSize)
          if (!tableObj) {
            const defaultSeats = Math.max(parseInt(this.autoAssignModal.defaultSeats) || 6, totalSize)
            const shapeToCreate = this.autoAssignModal.defaultShape || 'circle'
            const gridSpacing = 160
            const xPos = 120 + ((this.tableCounter) % 4) * gridSpacing
            const yPos = 120 + Math.floor((this.tableCounter) / 4) * gridSpacing
            this.createTableEntity(xPos, yPos, defaultSeats, shapeToCreate, '')
            tables = this.tableLayer.find('.gruppo_tavolo')
            this.transformer.nodes([])
            this.updateTableDragBounds()
            this.tableLayer.draw()
            tableObj = findTableForSize(totalSize)
          }
          if (tableObj) {
            const combinedGroupSlots = [...g1.slots, ...g2.slots]
            tableObj.seats.forEach((seat, idx) => {
              if (combinedGroupSlots[idx]) {
                newOccupancy[seat.id()] = combinedGroupSlots[idx].groupId
              }
            })
            assignedGroupUids.add(g1.uid)
            assignedGroupUids.add(g2.uid)
          }
        }
      })

      // 2. Gestione vincoli "same_table"
      sameTableRules.forEach(rule => {
        const g1 = guestGroups.find(g => g.uid === rule.guest1 && !assignedGroupUids.has(g.uid))
        const g2 = guestGroups.find(g => g.uid === rule.guest2 && !assignedGroupUids.has(g.uid))
        if (g1 && g2) {
          const targetTable = getTableForUid(rule.guest1) || getTableForUid(rule.guest2)
          let tableObj = null
          const totalSize = g1.size + g2.size

          if (targetTable) {
            const tSeats = targetTable.find('.seat-group')
            const freeSeats = tSeats.filter(s => !newOccupancy[s.id()])
            if (freeSeats.length >= totalSize) {
              tableObj = { table: targetTable, seats: freeSeats.slice(0, totalSize) }
            }
          }

          if (!tableObj) {
            tableObj = findTableForSize(totalSize)
          }

          if (!tableObj) {
            const defaultSeats = Math.max(parseInt(this.autoAssignModal.defaultSeats) || 6, totalSize)
            const shapeToCreate = this.autoAssignModal.defaultShape || 'circle'
            const gridSpacing = 160
            const xPos = 120 + ((this.tableCounter) % 4) * gridSpacing
            const yPos = 120 + Math.floor((this.tableCounter) / 4) * gridSpacing
            this.createTableEntity(xPos, yPos, defaultSeats, shapeToCreate, '')
            tables = this.tableLayer.find('.gruppo_tavolo')
            this.transformer.nodes([])
            this.updateTableDragBounds()
            this.tableLayer.draw()
            tableObj = findTableForSize(totalSize)
          }

          if (tableObj) {
            const combinedGroupSlots = [...g1.slots, ...g2.slots]
            tableObj.seats.forEach((seat, idx) => {
              if (combinedGroupSlots[idx]) {
                newOccupancy[seat.id()] = combinedGroupSlots[idx].groupId
              }
            })
            assignedGroupUids.add(g1.uid)
            assignedGroupUids.add(g2.uid)
          }
        }
      })

      // 3. Assegnazione di tutti gli altri gruppi rimanenti
      guestGroups.forEach(group => {
        if (assignedGroupUids.has(group.uid)) return

        let tableObj = null

        for (const table of tables) {
          let violatesDiff = false
          diffTableRules.forEach(r => {
            if (r.guest1 === group.uid || r.guest2 === group.uid) {
              const otherUid = r.guest1 === group.uid ? r.guest2 : r.guest1
              if (getTableForUid(otherUid) === table) violatesDiff = true
            }
          })

          if (!violatesDiff) {
            const tSeats = table.find('.seat-group')
            const freeSeats = tSeats.filter(s => !newOccupancy[s.id()])
            if (freeSeats.length >= group.size) {
              tableObj = { table, seats: freeSeats.slice(0, group.size) }
              break
            }
          }
        }

        if (!tableObj) {
          tableObj = findTableForSize(group.size)
        }

        // Se nessun tavolo ha abbastanza spazio per contenere il gruppo, ne crea uno ad hoc
        if (!tableObj) {
          const defaultSeats = Math.max(parseInt(this.autoAssignModal.defaultSeats) || 6, group.size)
          const shapeToCreate = this.autoAssignModal.defaultShape || 'circle'
          const gridSpacing = 160
          const xPos = 120 + ((this.tableCounter) % 4) * gridSpacing
          const yPos = 120 + Math.floor((this.tableCounter) / 4) * gridSpacing

          this.createTableEntity(xPos, yPos, defaultSeats, shapeToCreate, '')
          tables = this.tableLayer.find('.gruppo_tavolo')
          this.transformer.nodes([])
          this.updateTableDragBounds()
          this.tableLayer.draw()

          tableObj = findTableForSize(group.size)
        }

        if (tableObj) {
          tableObj.seats.forEach((seat, idx) => {
            if (group.slots[idx]) {
              newOccupancy[seat.id()] = group.slots[idx].groupId
            }
          })
          assignedGroupUids.add(group.uid)
        }
      })

      this.seatOccupancy = newOccupancy
      tables.forEach(t => this.generateSeats(t, t.getAttr('originalNumSeats')))

      this.salvaStage()

      this.autoAssignModal.visible = false
      loadingStore.commit('setLoading', false)
      M.toast({ html: this.translation('msg.auto.assign.complete'), classes: 'green' })
    },

    getTableSeatedGuests (tableGroup) {
      const seatedGuests = []
      const seatGroups = tableGroup.find('.seat-group')
      const guestSeatsMap = {}

      seatGroups.forEach(seatGroup => {
        const seatId = seatGroup.id()
        const figureId = this.seatOccupancy[seatId]
        if (figureId) {
          const guestUid = figureId.replace('guest-figure-', '')
          if (!guestSeatsMap[guestUid]) {
            guestSeatsMap[guestUid] = []
          }
          guestSeatsMap[guestUid].push(seatGroup)
        }
      })

      Object.keys(guestSeatsMap).forEach(guestUid => {
        const guestObject = this.guests.find(g => g.uid === guestUid)
        if (guestObject) {
          const seats = guestSeatsMap[guestUid]
          seats.sort((a, b) => {
            const indexA = parseInt(a.id().split('-').pop())
            const indexB = parseInt(b.id().split('-').pop())
            return indexA - indexB
          })

          seats.forEach((seat, idx) => {
            if (idx === 0) {
              seatedGuests.push({
                name: `${guestObject.name} ${guestObject.surname}`,
                isMain: true
              })
            } else {
              seatedGuests.push({
                name: `${guestObject.name} ${guestObject.surname} (Acc. ${idx})`,
                isMain: false
              })
            }
          })
        }
      })

      return seatedGuests
    },

    generateSeats (tableGroup, numSeats) {
      const newTableId = tableGroup.id()
      const tableElement = tableGroup.findOne('.table')
      const shape = tableGroup.getAttr('tableShape')
      const tableRotation = tableGroup.rotation() || 0

      tableGroup.find('.seat-group').forEach(seatGroup => {
        if (!this.seatOccupancy[seatGroup.id()]) {
          seatGroup.destroy()
        }
      })

      let seatPositions = []

      if (shape === 'circle') {
        const tableRadius = tableElement.radius()
        const seatRadius = this.seatVisualRadius
        const roundPadding = 6
        const distRadiusX = tableRadius + seatRadius + roundPadding
        const distRadiusY = tableRadius + seatRadius + roundPadding
        const angle = 360 / numSeats
        const radmult = Math.PI / 180

        for (let i = 0; i < numSeats; i++) {
          const posAngle = angle * i
          const x = distRadiusX * Math.cos(posAngle * radmult)
          const y = distRadiusY * Math.sin(posAngle * radmult)
          seatPositions.push({ x, y })
        }
      } else if (shape === 'rect') {
        const w = tableElement.width()
        const h = tableElement.height()
        const padding = 16

        const seatsOnShortSides = (numSeats < 2) ? numSeats : 2
        const seatsForLongSidesTotal = Math.max(0, numSeats - seatsOnShortSides)
        const seatsPerLongSide = Math.floor(seatsForLongSidesTotal / 2)
        const spacingX = w / (seatsPerLongSide + 1)

        for (let i = 1; i <= seatsPerLongSide; i++) {
          seatPositions.push({ x: (-w / 2) + spacingX * i, y: (-h / 2) - padding })
        }
        for (let i = 1; i <= seatsPerLongSide; i++) {
          seatPositions.push({ x: (-w / 2) + spacingX * i, y: (h / 2) + padding })
        }
        if (seatsOnShortSides >= 1) {
          seatPositions.push({ x: (-w / 2) - padding, y: 0 })
        }
        if (seatsOnShortSides === 2) {
          seatPositions.push({ x: (w / 2) + padding, y: 0 })
        }
        if (numSeats === 1) {
          seatPositions = [{ x: 0, y: (-h / 2) - padding }]
        }
      }

      seatPositions.forEach((pos, index) => {
        const seatId = `${newTableId}-seat-${index}`
        const figureId = this.seatOccupancy[seatId]
        const isOccupied = !!figureId

        let seatGroup = tableGroup.findOne(`#${seatId}`)

        if (!seatGroup) {
          seatGroup = new Konva.Group({
            name: 'seat-group',
            id: seatId,
            x: pos.x,
            y: pos.y
          })

          const seatBg = new Konva.Circle({
            name: 'seat',
            x: 0,
            y: 0,
            radius: this.seatVisualRadius,
            fill: '#E0E0E0',
            stroke: '#aaaaaa',
            strokeWidth: 1.5
          })
          seatGroup.add(seatBg)

          const userIcon = new Konva.Text({
            name: 'user-icon',
            text: '👤',
            fontSize: 14,
            fontFamily: 'Arial, sans-serif',
            fill: '#1565c0',
            rotation: -tableRotation,
            visible: false
          })
          userIcon.offsetX(userIcon.width() / 2)
          userIcon.offsetY(userIcon.height() / 2)
          userIcon.x(0)
          userIcon.y(0)
          seatGroup.add(userIcon)

          tableGroup.add(seatGroup)
          seatGroup.moveToBottom()

          seatGroup.on('mousedown touchstart', () => {
            if (seatGroup.getAttr('isOccupied')) {
              this.handleSeatDragStart(seatGroup, tableGroup)
            }
          })
          seatGroup.on('mouseenter', () => {
            if (seatGroup.getAttr('isOccupied')) {
              const sId = seatGroup.id()
              const fId = this.seatOccupancy[sId]
              if (fId) {
                const guestUid = fId.replace('guest-figure-', '')
                const guestObject = this.guests.find(g => g.uid === guestUid)
                if (guestObject) {
                  const seatGuestsMap = {}
                  tableGroup.find('.seat-group').forEach(sg => {
                    const currentSId = sg.id()
                    const currentFId = this.seatOccupancy[currentSId]
                    if (currentFId === fId) {
                      if (!seatGuestsMap[currentFId]) seatGuestsMap[currentFId] = []
                      seatGuestsMap[currentFId].push(sg)
                    }
                  })
                  const guestSeatList = seatGuestsMap[fId] || []
                  guestSeatList.sort((a, b) => parseInt(a.id().split('-').pop()) - parseInt(b.id().split('-').pop()))
                  const seatIdx = guestSeatList.findIndex(sg => sg.id() === sId)

                  let displayName = `${guestObject.name} ${guestObject.surname}`
                  if (seatIdx > 0) {
                    displayName += ` (Acc. ${seatIdx})`
                  }

                  const absPos = seatGroup.getAbsolutePosition()
                  const renderBelow = absPos.y - 30 < 0

                  this.tooltip = {
                    visible: true,
                    text: displayName,
                    x: absPos.x,
                    y: renderBelow ? (absPos.y + 18) : (absPos.y - 12),
                    below: renderBelow
                  }
                }
              }
            }
          })

          seatGroup.on('mouseleave', () => {
            this.tooltip.visible = false
          })
        }

        seatGroup.x(pos.x)
        seatGroup.y(pos.y)
        seatGroup.setAttr('isOccupied', isOccupied)

        if (isOccupied) {
          const guestUid = figureId.replace('guest-figure-', '')
          seatGroup.setAttr('guestUid', guestUid)
          const guestObject = this.guests.find(g => g.uid === guestUid)
          if (guestObject) {
            seatGroup.setAttr('guestName', guestObject.name)
            seatGroup.setAttr('guestSurname', guestObject.surname)
          }
        } else {
          seatGroup.setAttr('guestUid', null)
          seatGroup.setAttr('guestName', null)
          seatGroup.setAttr('guestSurname', null)
        }

        const seatBg = seatGroup.findOne('.seat')
        const userIcon = seatGroup.findOne('.user-icon')

        if (isOccupied) {
          seatBg.fill('#ffffff')
          seatBg.stroke('#1565c0')
          userIcon.rotation(-tableRotation)
          userIcon.visible(true)
        } else {
          seatBg.fill('#E0E0E0')
          seatBg.stroke('#aaaaaa')
          userIcon.visible(false)
        }
      })

      this.updateTableDragBounds()
      this.tableLayer.draw()
    },

    dragStartGroup (guest) {
      this.tooltip.visible = false
      const guestUid = guest.uid
      this.draggedGuestUid = 'guest-figure-' + guestUid

      const groupElements = document.querySelectorAll(`.guest-group-entry div.guest-figure[data-group-uid="${guestUid}"]`)
      groupElements.forEach(el => {
        el.style.opacity = '0.4'
      })

      this.tableLayer.find('.gruppo_tavolo').forEach(tableGroup => {
        let needsRegen = false
        tableGroup.find('.seat-group').forEach(seatGroup => {
          const seatId = seatGroup.id()
          if (this.seatOccupancy[seatId] === this.draggedGuestUid) {
            this.$delete(this.seatOccupancy, seatId)
            needsRegen = true
          }
        })
        if (needsRegen) {
          this.generateSeats(tableGroup, tableGroup.getAttr('originalNumSeats'))
        }
      })

      const tempFigure = new Konva.Circle({
        x: this.stage.getPointerPosition().x,
        y: this.stage.getPointerPosition().y,
        radius: this.seatVisualRadius * 1.4,
        fill: this.getGuestColor(guestUid),
        stroke: 'black',
        strokeWidth: 2,
        draggable: true,
        id: this.draggedGuestUid,
        name: 'guest-figure-temp',
        guestUid: guestUid,
        totalSeatsNeeded: 1 + (guest.accompanying_persons || 0)
      })

      this.figureLayer.add(tempFigure)
      this.figureLayer.draw()

      tempFigure.startDrag()
      tempFigure.on('dragend', (e) => this.checkDropCollision(e.target))
    },

    handleSeatDragStart (seatGroup, tableGroup) {
      this.tooltip.visible = false
      const seatId = seatGroup.id()
      const figureId = this.seatOccupancy[seatId]
      if (!figureId) return

      const guestUid = figureId.replace('guest-figure-', '')
      const guestObject = this.guests.find(g => g.uid === guestUid)
      if (!guestObject) return

      Object.keys(this.seatOccupancy).forEach(sId => {
        if (this.seatOccupancy[sId] === figureId) {
          this.$delete(this.seatOccupancy, sId)
        }
      })

      this.generateSeats(tableGroup, tableGroup.getAttr('originalNumSeats'))
      this.dragStartGroup(guestObject)
    },

    restoreSidebarVisibility (guestUid) {
      const groupElements = document.querySelectorAll(`.guest-group-entry div.guest-figure[data-group-uid="${guestUid}"]`)
      groupElements.forEach(el => {
        el.style.opacity = '1'
      })
    },

    findConsecutiveSeatGroups (tableSeats, targetIndex, seatsRequired, figureId, direction = 1) {
      const totalSeats = tableSeats.length
      const availableSeats = []
      let hasCollision = false

      for (let i = 0; i < seatsRequired; i++) {
        let seatIndex

        if (direction === 1) {
          seatIndex = (targetIndex + i) % totalSeats
        } else {
          seatIndex = (targetIndex - i) % totalSeats
          if (seatIndex < 0) {
            seatIndex += totalSeats
          }
        }

        const currentSeat = tableSeats[seatIndex]
        const currentSeatId = currentSeat.id()

        if (this.seatOccupancy[currentSeatId] && this.seatOccupancy[currentSeatId] !== figureId) {
          hasCollision = true
          break
        }
        availableSeats.push(currentSeat)
      }

      if (hasCollision || availableSeats.length < seatsRequired) {
        return null
      }

      if (direction === -1) {
        availableSeats.reverse()
      }

      return availableSeats
    },

    checkDropCollision (draggedFigure) {
      const guestUid = draggedFigure.getAttr('guestUid')
      const figureId = 'guest-figure-' + guestUid
      const figureAbsPos = draggedFigure.getAbsolutePosition()
      const seatGroups = this.tableLayer.find('.seat-group')
      const seatsRequired = draggedFigure.getAttr('totalSeatsNeeded') || 1

      let targetSeatGroup = null
      const DROP_RADIUS = draggedFigure.radius() + this.seatVisualRadius

      for (const seatGroup of seatGroups) {
        const seatAbsPos = seatGroup.getAbsolutePosition()
        const dx = figureAbsPos.x - seatAbsPos.x
        const dy = figureAbsPos.y - seatAbsPos.y
        const distance = Math.sqrt(dx * dx + dy * dy)

        if (distance <= DROP_RADIUS) {
          targetSeatGroup = seatGroup
          break
        }
      }

      if (targetSeatGroup) {
        const tableGroup = targetSeatGroup.getParent()
        const tableSeats = tableGroup.find('.seat-group')
        const totalSeats = tableSeats.length

        let availableSeats = null

        if (seatsRequired > totalSeats) {
          M.toast({ html: this.translation('msg.error.table.full'), classes: 'red' })
        } else {
          const targetIndex = tableSeats.findIndex(s => s.id() === targetSeatGroup.id())

          availableSeats = this.findConsecutiveSeatGroups(tableSeats, targetIndex, seatsRequired, figureId, 1)
          if (!availableSeats) {
            availableSeats = this.findConsecutiveSeatGroups(tableSeats, targetIndex, seatsRequired, figureId, -1)
          }

          if (!availableSeats) {
            for (let i = 0; i < totalSeats; i++) {
              if (i === targetIndex) continue
              availableSeats = this.findConsecutiveSeatGroups(tableSeats, i, seatsRequired, figureId, 1)
              if (availableSeats) break
              availableSeats = this.findConsecutiveSeatGroups(tableSeats, i, seatsRequired, figureId, -1)
              if (availableSeats) break
            }
          }
        }

        if (!availableSeats) {
          draggedFigure.remove()
          this.restoreSidebarVisibility(guestUid)
          this.figureLayer.destroyChildren()
          this.figureLayer.draw()
          this.tableLayer.draw()
          if (seatsRequired <= totalSeats) {
            M.toast({ html: this.translation('msg.error.table.full.001'), classes: 'orange' })
          }
          return
        }

        for (const seatGroup of availableSeats) {
          const seatId = seatGroup.id()
          this.$set(this.seatOccupancy, seatId, figureId)
        }

        this.generateSeats(tableGroup, tableGroup.getAttr('originalNumSeats'))
        draggedFigure.remove()
      } else {
        draggedFigure.remove()
        this.restoreSidebarVisibility(guestUid)
      }

      this.figureLayer.destroyChildren()
      this.figureLayer.draw()
      this.tableLayer.draw()
      this.salvaStage()
    },

    async salvaStage () {
      this.tooltip.visible = false
      this.transformer.nodes([])
      this.tableLayer.draw()

      this.stage.width(this.stageWidth)
      this.stage.height(this.stageHeight)

      const stageJSON = this.stage.toJSON()
      const konvaJson = JSON.parse(stageJSON)

      // --- INIEZIONE ATTRIBUTO isAccompanying NEL KONVA_SCHEMA ---
      konvaJson.children.forEach(layer => {
        if (layer.attrs && layer.attrs.name === 'TableLayer' && layer.children) {
          layer.children.forEach(tableGroup => {
            if (tableGroup.attrs && tableGroup.attrs.name === 'gruppo_tavolo' && tableGroup.children) {
              // 1. Raggruppa i seat-group per guestUid basandosi sia su Konva che su seatOccupancy
              const seatGuestsMap = {}
              tableGroup.children.forEach(child => {
                if (child.attrs && child.attrs.name === 'seat-group') {
                  const seatId = child.attrs.id
                  const figureId = this.seatOccupancy[seatId]
                  if (figureId) {
                    const guestUid = figureId.replace('guest-figure-', '')
                    if (!seatGuestsMap[guestUid]) {
                      seatGuestsMap[guestUid] = []
                    }
                    seatGuestsMap[guestUid].push(child)
                  } else {
                    // Se il posto non è occupato, non è un accompagnatore
                    child.attrs.isAccompanying = false
                  }
                }
              })

              // 2. Ordina i posti per indice numerico e assegna l'attributo
              Object.keys(seatGuestsMap).forEach(guestUid => {
                const seats = seatGuestsMap[guestUid]
                seats.sort((a, b) => {
                  const indexA = parseInt(a.attrs.id.split('-').pop())
                  const indexB = parseInt(b.attrs.id.split('-').pop())
                  return indexA - indexB
                })

                seats.forEach((seatNode, idx) => {
                  // idx === 0 -> Ospite principale (false)
                  // idx > 0  -> Accompagnatore (true)
                  seatNode.attrs.isAccompanying = idx > 0
                })
              })
            }
          })
        }
      })
      // -------------------------------------------------------------

      konovaschema.dispatch('aggiornakonova', konvaJson)
      localStorage.setItem('activeTableSchema', JSON.stringify(konvaJson))

      const currentRoom = this.roomDataFromStore || this.roomData || {}
      const roomId = currentRoom.uid || currentRoom.id || currentRoom.uuid || this.$route.params.uid || this.$route.query.uid

      if (!roomId) {
        M.toast({ html: this.translation('msg.error.table.not.found'), classes: 'red' })
        return
      }

      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        this.$router.push('/error')
        return
      }

      loadingStore.commit('setLoading', true)

      const url = `${process.env.VUE_APP_URL_EVENTS}/table/update-room/${roomId}`

      const payload = {
        name: currentRoom.name || '',
        description: currentRoom.description || '',
        color: currentRoom.color || null,
        img: currentRoom.img || null,
        event_uid: currentRoom.event_uid || this.uidEvent || null,
        session_uid: currentRoom.session_uid || null,
        jsonable: {
          table: currentRoom.jsonable?.table || `table-${(currentRoom.name || 'room').toLowerCase().replace(/\s/g, '-')}`,
          konva_schema: konvaJson, // Ora contiene i seat-group con "isAccompanying"
          width: this.stageWidth,
          height: this.stageHeight,
          seatOccupancy: this.seatOccupancy
        }
      }

      try {
        const json = await apiService.sendRequestWithBearer('PUT', url, token, payload)

        konovaschema.commit('setRoomData', json)
        localStorage.setItem('activeTableInfo', JSON.stringify(json))

        try {
          const settingsString = localStorage.getItem('SettingsStore')
          if (settingsString) {
            const settings = JSON.parse(settingsString)
            if (settings.eventModel && Array.isArray(settings.eventModel.rooms)) {
              const roomIndex = settings.eventModel.rooms.findIndex(r => (r.uid === roomId || r.id === roomId || r.uuid === roomId))
              if (roomIndex !== -1) {
                settings.eventModel.rooms[roomIndex] = json
              } else {
                settings.eventModel.rooms.push(json)
              }
              localStorage.setItem('SettingsStore', JSON.stringify(settings))
            }
          }
        } catch (err) {
          // console.error('Errore aggiornamento SettingsStore rooms:', err)
        }

        M.toast({ html: this.translation('msg.suscces.save.table.allocation'), classes: 'green' })
      } catch (error) {
        // console.error('Errore durante l\'aggiornamento della stanza:', error)
        M.toast({ html: this.translation('msg.error.save.001'), classes: 'red' })
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },
    resetAll () {
      this.tooltip.visible = false
      this.transformer.nodes([])
      this.tableLayer.destroyChildren()
      this.figureLayer.destroyChildren()

      if (this.tableLayer) {
        this.transformer = new Konva.Transformer({
          rotateEnabled: true,
          borderStroke: 'blue',
          anchorFill: 'blue',
          anchorStroke: 'blue',
          enabledAnchors: []
        })
        this.tableLayer.add(this.transformer)
      }

      this.tableLayer.draw()
      this.figureLayer.draw()

      this.seatOccupancy = {}
      this.tableCounter = 0
      this.seats = null

      this.guests.forEach(g => {
        this.restoreSidebarVisibility(g.uid)
      })
      this.initMaterializeComponents()
    }
  },
  watch: {
    tableShape () {
      this.initMaterializeComponents()
    },
    seats () {
      this.initMaterializeComponents()
    },
    translation () {
      this.initMaterializeComponents()
    }
  }
}
</script>

<style scoped>
.corpo-pagina {
  padding: 20px;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.page-title {
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
}

.controls-row {
  background: #fff;
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.action-buttons-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.table-manager-container {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  margin-bottom: 0 !important;
}

.guest-sidebar-col {
  display: flex;
  flex-direction: column;
}

.sidebar-card {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 700px;
}

.sidebar-title {
  font-size: 1.2rem;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.guest-list-scroll {
  overflow-y: auto;
  flex-grow: 1;
  padding-right: 4px;
}

.guest-group-entry {
  margin-bottom: 8px;
}

.guest-figure {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  color: white;
  cursor: grab;
  transition: opacity 0.3s, box-shadow 0.1s;
  user-select: none;
  font-size: 13.5px;
}

.guest-figure:active {
  cursor: grabbing;
}

.guest-figure.main-guest {
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.dimension-accompanying {
  font-size: 12px;
  padding: 5px 8px;
  margin-left: 15px;
  opacity: 0.9;
  font-style: italic;
  font-weight: normal;
}

.accompanying-count {
  font-weight: normal;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 12px;
}

.canvas-col {
  display: flex;
  flex-direction: column;
}

#container-wrapper {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fafafa;
  flex-grow: 1;
  min-height: 550px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.custom-html-tooltip {
  position: absolute;
  transform: translate(-50%, -100%);
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-family: Arial, sans-serif;
  pointer-events: none;
  z-index: 999999999999;
  white-space: pre-line;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

/* Gestione automatica del tooltip quando è vicino al bordo superiore */
.custom-html-tooltip.tooltip-below {
  transform: translate(-50%, 0);
}

.resizable-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: se-resize;
  border-top-left-radius: 8px;
  transition: background 0.2s;
  z-index: 10;
}

.resizable-handle:hover {
  background: rgba(0, 0, 0, 0.8);
}

.resizable-handle i {
  font-size: 18px;
}

.table-guests-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeInModal 0.2s ease-out;
}

@keyframes fadeInModal {
  from { opacity: 0; transform: scale(0.97); }
  to { opacity: 1; transform: scale(1); }
}

.table-guests-card {
  background: #ffffff;
  border-radius: 16px;
  width: 460px;
  max-width: 92%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.table-guests-header {
  padding: 20px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9;
}

.table-guests-header h5 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.btn-close-modern {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: background-color 0.2s, color 0.2s;
}

.btn-close-modern:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.table-guests-body {
  padding: 20px 24px 24px;
  overflow-y: auto;
  flex-grow: 1;
}

.table-name-action-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-modern {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-weight: 500;
  text-transform: none;
  font-size: 13px;
  height: 36px;
  line-height: 36px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease, opacity 0.2s;
}

.btn-modern:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.section-divider {
  height: 1px;
  background-color: #f1f5f9;
  width: 100%;
}

.guests-section-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #475569;
  margin: 0;
}

.modern-guests-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
  padding-right: 4px;
}

.modern-guest-item {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 10px 14px;
  border-radius: 10px;
  transition: background-color 0.2s;
}

.modern-guest-item:hover {
  background: #f1f5f9;
}

.guest-avatar-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #e0f2fe;
  color: #0284c7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.guest-avatar-icon i {
  font-size: 16px;
}

.guest-item-name {
  color: #334155;
  font-size: 14px;
  flex-grow: 1;
}

.guest-tag-acc {
  font-size: 11px;
  background-color: #f1f5f9;
  color: #64748b;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
}

.rule-builder-box {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.rules-list-scroll {
  max-height: 180px;
  overflow-y: auto;
  margin-top: 10px;
}

.font-small {
  font-size: 0.85rem;
}

.w-100 {
  width: 100% !important;
}
</style>

<style>
.dropdown-content {
  max-height: 250px !important;
  overflow-y: auto !important;
  z-index: 999999 !important;
}
</style>
